import { Component, Input, OnDestroy, OnChanges, AfterViewInit, ViewChild, SimpleChanges } from '@angular/core';

@Component({
	selector: 'port-poe-status',
	templateUrl: './port-poe-status.component.html',
	styleUrls: ['./port-poe-status.component.scss']
})
export class PortPoeStatusComponent {

	constructor() {

	}

}